var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_76973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6569 2L13.5502 2.02L9.99023 3.4L5.99023 2L2.23023 3.26667C2.09023 3.31333 1.99023 3.43333 1.99023 3.58667V13.6667C1.99023 13.8533 2.1369 14 2.32357 14L2.43023 13.98L5.99023 12.6L9.99023 14L13.7502 12.7333C13.8902 12.6867 13.9902 12.5667 13.9902 12.4133V2.33333C13.9902 2.14667 13.8436 2 13.6569 2ZM6.6569 3.64667L9.32357 4.58V12.3533L6.6569 11.42V3.64667ZM3.32357 4.30667L5.32357 3.63333V11.4333L3.32357 12.2067V4.30667ZM12.6569 11.6933L10.6569 12.3667V4.57333L12.6569 3.8V11.6933Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_76973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5ca314942f4460598312558b548d1e7f.svg";
export { ForwardRef as ReactComponent };